export enum BannerType {
  Search = "Search",
}
